import { render } from "./Admissions.vue?vue&type=template&id=544a07f8"
import script from "./Admissions.vue?vue&type=script&lang=js"
export * from "./Admissions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__